export const getResponse = (service) => {
  return service?.data?.response || {};
};
